// @ts-check
import { defineConfig } from '../utils';

export function informationBar() {
  return defineConfig({
    properties: {
      'BarraInformacion.MostrarBarra': {
        defaultValue: false,
      },
      'BarraInformacion.MostrarNombreUsuario': {
        defaultValue: true,
      },
      'BarraInformacion.MostrarRuta': {
        defaultValue: true,
      },
      'BarraInformacion.MostrarCentro': {
        defaultValue: true,
      },
      'BarraInformacion.MostrarVersionApp': {
        defaultValue: true,
      },
      'BarraInformacion.OrdenElementos': {
        defaultValue: [
          'username',
          'route',
          'center',
          'appVersion',
        ],
      },
    },
  });
}
